module.exports = __webpack_public_path__ + "assets/paypal-w.acdd5369.png";